import * as React from "react";
import { useTranslation } from "react-i18next";
import { DocumentTitle } from "components/common";
import { getEnterpriseGroupSyncPlugin } from "util/AuthenticationService";
import WizardPageHeader from "./WizardPageHeader";
import handleCreate from "../HandleCreate";
import BackendWizard from "../BackendWizard";
import HelpText from "../HelpText";
export const AUTH_BACKEND_META = {
  serviceType: "ldap",
  serviceTitle: "LDAP"
};
export const HELP = {
  // server config help
  systemUserDn: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "ldap.help.system_user_dn" }),
  systemUserPassword: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "ldap.help.system_user_password" }),
  // user sync help
  userSearchBase: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "ldap.help.user_search_base" }),
  userSearchPattern: /* @__PURE__ */ React.createElement(
    HelpText,
    {
      i18nKey: "directory_help.user_search_pattern",
      values: { example: "(&(uid={0})(objectClass=inetOrgPerson))", placeholder: "{0}" }
    }
  ),
  userNameAttribute: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "ldap.help.user_name_attribute" }),
  userFullNameAttribute: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "ldap.help.user_full_name_attribute" }),
  userUniqueIdAttribute: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "ldap.help.user_unique_id_attribute" }),
  defaultRoles: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "directory_help.default_roles" }),
  defaultUserTimezone: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "directory_help.default_user_timezone" }),
  emailAttributes: /* @__PURE__ */ React.createElement(HelpText, { i18nKey: "ldap.help.email_attributes" })
};
const INITIAL_VALUES = {
  title: AUTH_BACKEND_META.serviceTitle,
  serverHost: "localhost",
  serverPort: 636,
  transportSecurity: "tls",
  userFullNameAttribute: "cn",
  emailAttributes: ["mail", "rfc822Mailbox"],
  userNameAttribute: "uid",
  userUniqueIdAttribute: "entryUUID",
  verifyCertificates: true
};
const BackendCreate = () => {
  var _a, _b;
  const { t } = useTranslation("authentication");
  const enterpriseGroupSyncPlugin = getEnterpriseGroupSyncPlugin();
  const { help: groupSyncHelp = {}, initialValues: initialGroupSyncValues = {} } = (_b = (_a = enterpriseGroupSyncPlugin == null ? void 0 : enterpriseGroupSyncPlugin.wizardConfig) == null ? void 0 : _a.ldap) != null ? _b : {};
  const help = { ...HELP, ...groupSyncHelp };
  const initialValues = { ...INITIAL_VALUES, ...initialGroupSyncValues };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("ldap.create_title") }, /* @__PURE__ */ React.createElement(WizardPageHeader, null), /* @__PURE__ */ React.createElement(
    BackendWizard,
    {
      onSubmit: handleCreate,
      help,
      authBackendMeta: AUTH_BACKEND_META,
      initialValues
    }
  ));
};
export default BackendCreate;
